import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dreamy%20romantic%20landscape%20at%20sunset%20with%20a%20beautiful%20tropical%20island%20silhouette%2C%20pink%20and%20golden%20clouds%20reflecting%20on%20calm%20ocean%20water%2C%20soft%20ethereal%20atmosphere%2C%20cinematic%20wide%20panoramic%20view%2C%20warm%20romantic%20mood%2C%20artistic%20and%20dreamlike%20quality&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="爱情岛视频 - 高清在线观看"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-fire-line text-accent-400 text-sm"></i>
          </div>
          <span className="text-white/90 text-xs font-medium">2026最新爱情岛视频资源每日更新</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          {t('home.hero.title')}
          <span className="block text-xl md:text-2xl lg:text-3xl font-body font-normal mt-2 text-white/80">
            {t('home.hero.subtitle')}
          </span>
        </h1>

        <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('home.hero.description')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/quanji"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            <span className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-play-circle-fill"></i>
              </div>
              {t('home.hero.cta')}
            </span>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
          >
            {t('home.hero.secondary')}
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mt-12 max-w-[700px] mx-auto">
          {[
            { value: '500+', label: t('home.stats.videos') },
            { value: '200万+', label: t('home.stats.users') },
            { value: '98%', label: t('home.stats.rating') },
            { value: '5+', label: t('home.stats.updates') },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">{stat.value}</div>
              <div className="text-xs text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}